import React, { useEffect, useState } from "react"

import { FooterI, HomePageI } from "../../interface"
import FindaHotel from "../../components/FindaHotel/FindaHotel"

import ChevronRight from "../../assets/images/ic_chevron_right_24px_white.svg"

import "./RHRDescriptionAndForm.scss"
import Markdown from "markdown-to-jsx"

const RHRDescription = ({ data }) => {
  const [homePageData, sethomePageData] = useState<HomePageI>()

  useEffect(() => {
    if (data?.tarsiergraphql?.getHomepageDetails) {
      sethomePageData(data.tarsiergraphql.getHomepageDetails)
    }
  }, [data])

  const [title, setTitle] = useState("")
  const [subheader, setSubheader] = useState("")
  const [description, setDescription] = useState("")

  useEffect(() => {
    const sanitizeContent = async () => {
      if (typeof window === "undefined") return

      const mod = await import("dompurify")
      const createDOMPurify = mod.default || mod
      const DOMPurify = createDOMPurify(window)

      setTitle(DOMPurify.sanitize(homePageData?.title ?? ""))
      setSubheader(DOMPurify.sanitize(homePageData?.sub_header ?? ""))
      setDescription(DOMPurify.sanitize(homePageData?.description ?? ""))
    }

    sanitizeContent()
  }, [homePageData])

  return (
    <div className="rhr-container">
      <div className="rhr-description">
        <Markdown
          options={{
            overrides: {
              p: {
                component: "h2",
                props: { className: "title-border" },
              },
            },
          }}
        >
          {title}
        </Markdown>

        <Markdown
          options={{
            overrides: {
              p: {
                component: "span",
              },
            },
          }}
        >
          {subheader}
        </Markdown>

        <Markdown
          options={{
            overrides: {
              p: {
                component: "div",
                props: { className: "description" },
              },
            },
          }}
        >
          {description}
        </Markdown>

        <a href="/about-us#who-we-are">
          Know More <img src={ChevronRight} alt="Chevron Right" />
        </a>
      </div>
      <FindaHotel
        data={data}
        dropdownClassName="certain-category-search-dropdown"
        placeholder="Hotel Location: e.g. Cebu, Manila"
        containerId="findhotelSideform"
        formID="formHotel1"
        bookingFormStatus={true}
      />
    </div>
  )
}

export default RHRDescription
